/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 22.12.2016.
 */

import ReducerVlive from './reducer-vlive'

export default ReducerVlive;



// WEBPACK FOOTER //
// ./src/reducers/vlive/index.js